import { AmbassadorRoute } from 'data/records'
import { findSelector } from 'data/helpers/apiv3'

const selectors = {
  ...findSelector(AmbassadorRoute),
  byRouteId: (state, routeId) => state.apiv3.ambassadorRoute.id.find(e => e.routeId === routeId)
}

export {
  selectors as ambassadorRouteSelectors
}
